<template>
    <el-drawer
        title="热度设置"
        :visible.sync="drawerShow"
        :wrapperClosable="false"
        :destroy-on-close="true"
        size="auto"
        @close="close"
    >
        <div v-if="itemData" class="drawer-content">
            <el-form
                :model="formDatas"
                :rules="rules"
                ref="formDatas"
                label-position="top"
                size="medium"
            >
                <el-form-item>
                    <span slot="label">
                        系统热度值：{{itemData.hot}}
                    </span>
                </el-form-item>
                <el-form-item prop="type">
                    <span slot="label">调整类型: </span>
                    <el-radio-group v-model="formDatas.type">
                        <el-radio :label="1" border>增加</el-radio>
                        <el-radio :label="2" border>减少</el-radio>
                    </el-radio-group>
                    <div><small class="form-tips color-danger">设置基础热度值系统热度值基础上人为提高或降低动态热度总和</small></div>
                </el-form-item>
                <el-form-item prop="num" label="调整数字:">
                    <el-input-number style="width:100%" v-model="formDatas.num" :precision="0" controls-position="right" :min="1" :max="99999999" size="medium" placeholder="请输入调整数字"></el-input-number>
                </el-form-item>
                <el-form-item>
                    <span slot="label">
                        最新系统热度值：{{itemData.hot + (formDatas.type == 1 ? formDatas.num : -parseInt(formDatas.num)) || 0 }}
                    </span>
                </el-form-item>
            </el-form>
        </div>
        <div class="drawer-footer">
            <el-button @click="close">取消</el-button>
            <el-button type="primary" @click="submitForm()" :loading="btnLoading"
                >确认</el-button
            >
        </div>
    </el-drawer>
</template>
<script>
const defaultData = {
    type:1,
    num: undefined
}
export default {
    data(){
        return{
            drawerShow: false,
            btnLoading: false,
            formDatas:{
                ...defaultData
            },
            itemData: null,
            rules:{
                num:[{ required: true, message: "请填写增/减热度", trigger:"blur" }]
            },
        }
    },
    methods:{
        close(){
            this.$refs.formDatas.resetFields();
            this.drawerShow = false;
            this.itemData = null;
            this.formDatas = {
                ...defaultData
            }
        },
        show(data){
            this.itemData = {
                ...data,
                hot: data.hot || 0
            };
            this.drawerShow = true;
        },
        submitForm(){
            this.$refs["formDatas"].validate((valid) => {
                if (valid) {
                    this.btnLoading = true;    
                    this.$request({
                        url: '/article/updateHot',
                        params: {
                            id: this.itemData.id,
                            hot: this.formDatas.type == 1 ? this.formDatas.num : -parseInt(this.formDatas.num)
                        },
                        method: "post",
                    })
                        .then((res) => {
                            const { state, msg } = res.data;
                            if (state == 1) {
                                this.$emit('onUpdate');
                                this.close();
                            } else {
                                this.$message.error(msg || "操作失败,请重试");
                            }
                        })
                        .catch(() => {
                            this.$message.error("操作失败,请重试");
                        })
                        .finally(() => {
                            this.btnLoading = false;
                        });   
                } else {
                    return false;
                }
            });
        }
    }
}
</script>

<style lang="scss" scoped>

</style>